//高级函数--7个
export const AdvancedFunc = [
  {
    "key": "if",
    "name": "if()\n{\n\n}",
    "params": [],
    "description": "if条件成立，执行括号中内容",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "if else",
    "name": "if()\n{\n\n}\nelse\n{\n\n}",
    "params": [],
    "description": "if条件成立，执行括号中内容；否则执行else中内容",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "for",
    "name": "for(;;)\n{\n\n}",
    "params": [],
    "description": "for循环：示例：for(var i=0;i<5;i++){}",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "return",
    "name": "return ;",
    "params": [],
    "description": "返回值",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "var",
    "name": "var ",
    "params": [],
    "description": "变量定义",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "true",
    "name": "true ",
    "params": [],
    "description": "正确",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "false",
    "name": "false ",
    "params": [],
    "description": "错误",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "Invoke",
    "name": "内置扩展调用",
    "params": [],
    "description": "内置扩展调用函数调用方法",
    "type": "",
    "keyFront": "DefaultExtendFunctionProxy",
    "className": ""
  }
]